import { nextTick } from 'vue';

// Identifies all types of error from creating or editing trays
const FORM_ERROR_SELECTOR = [
  '[aria-invalid="true"]',
  '.tray-form__field-error',
  '.tray-form__error',
  '.tray-edit-form__error',
  '.focal-point-picker__error',
].join(', ');

/**
 * Scroll the first validation error in the form. If multiple, the user can see them all as they work down.
 * @param {string} [scopeSelector] Restrict the search to a container, e.g. '#tray-form'.
 */
export async function scrollToFirstFormError(scopeSelector) {
  await nextTick();

  const root = (scopeSelector && document.querySelector(scopeSelector)) || document;
  const firstError = root.querySelector(FORM_ERROR_SELECTOR);

  firstError?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
